import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue"

import { LocaleString } from '@/api-client/models/utilization/Contracts'
import KPICard from '../components/cards/KPICard.vue'
import { sharedDataKey } from '../../types'
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { FormatOptions } from '../formatter'
import { ColorScaleConfig } from '@/utils/colorScale'

export type Measurement = {
  title: LocaleString
  info: LocaleString
  props: {
    color: string
    colorScale: ColorScaleConfig
    format: FormatOptions
    metadataFormat?: Record<string, FormatOptions>
    metadataLabels?: Record<string, LocaleString>
    dataSource: string
  }
}

type Props = {
  measurements: Measurement[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MeasurementCardList',
  props: {
    measurements: {}
  },
  setup(__props: any) {



const { locale } = useI18n()

const sharedData = inject(sharedDataKey)

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measurements, (measurement, i) => {
    return (_openBlock(), _createBlock(KPICard, {
      key: i,
      title: measurement.title[_unref(locale)],
      kpiInfo: measurement.info?.[_unref(locale)],
      fullscreen: _unref(sharedData)?.fullscreen ?? false,
      dataSource: measurement.props.dataSource,
      kpiFormat: measurement.props.format,
      metadataFormat: measurement.props.metadataFormat,
      metadataLabels: measurement.props.metadataLabels,
      color: measurement.props.color,
      colorScale: measurement.props.colorScale,
      first: i === 0,
      isLoading: false,
      showOnMap: false,
      showOnMapEnabled: true
    }, null, 8, ["title", "kpiInfo", "fullscreen", "dataSource", "kpiFormat", "metadataFormat", "metadataLabels", "color", "colorScale", "first"]))
  }), 128))
}
}

})